import FieldsConstants from './fields.constants';
import { DetectDeviceService } from './user-agent.helpers';

/**
 * Unix (from which OS X closely derives) and Windows don't have the same way of
 * "recording" changing lines in files: in DOS and Windows, going to the next line,
 * whether manually when typing or because you imported a txt file made by someone
 * else (or another machine) means using a "carriage return" (yeah, I know, sounds old),
 * where Unix uses a "line feed". A carriage return will first send the carret back
 * to the beginning of the last line you typed in, before switching to the next line
 * so you can resume typing, whereas a line feed will jump to the next line directly.
 * This leads to some invisible extra characters being typed, and since each digit
 * or key press brings its own byte or octet in the balance,
 * your files might end up being heavier under one platform than they were in another.
 * Differences in the drive's block size is one reason.
 * Another is the difference in the filesystem, and another
 * is Windows uses the standard GB while Macs use a GB = 1,000,000,000 bytes.
 * @param fileSize
 */
export function isValidFileSize(fileSize: number): boolean {
  return DetectDeviceService.isIOSPlatform()
    ? fileSize <= FieldsConstants.MAX_FILE_MANAGER_FILE_SIZE_IN_BYTE_IOS
    : fileSize <= FieldsConstants.MAX_FILE_MANAGER_FILE_SIZE_IN_BYTE;
}
